<template>
  <div id="wrapper">
    <SidebarView :budgets="true" :budgetsApprovals="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <div class="container">
          <div class="card card-shape home-box">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-12">
                  <h6 class="m-0 fw-bold text-green">Budget Approvals</h6>
                  <div class="small text-muted">Budget ID: {{ budgetId }}</div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div v-if="canApproveLock">
                <b-alert v-if="budget && budget.status" show variant="secondary">
                  Current status: <strong class="text-uppercase">{{ budget.status }}</strong>
                </b-alert>

                <div class="row g-3">
                  <div class="col-12">
                    <b-button
                      class="btn akkurate-green-btn text-white btn-size me-2"
                      :disabled="isProcessing || !canApprove"
                      @click="approveBudget"
                    >
                      {{ isProcessing && processingAction === 'approve' ? "Approving..." : "Approve" }}
                    </b-button>
                    <b-button
                      class="btn akkurate-danger-btn text-white btn-size"
                      :disabled="isProcessing || !canLock"
                      @click="lockBudget"
                    >
                      {{ isProcessing && processingAction === 'lock' ? "Locking..." : "Lock" }}
                    </b-button>
                  </div>
                  <div class="col-12 small text-muted">
                    Approve: draft → approved. Lock: approved → locked.
                  </div>
                </div>
              </div>
              <a href="/budgets" class="btn akkurate-gray-btn text-white btn-size">Back to Budgets</a>
            </div>
          </div>
        </div>
      </div>
      <footer></footer>
    </div>
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import ApiService from "@/core/services/api.service";
import { hasPermission } from "@/helper";

export default {
  name: "BudgetApprovals",
  components: { SidebarView, TopbarView },
  data() {
    return {
      noAccess: false,
      isProcessing: false,
      processingAction: "",
      budget: null,
    };
  },
  computed: {
    budgetId() {
      return this.$route?.params?.budgetId;
    },
    canApproveLock() {
      return hasPermission("budgets_approve_lock");
    },
    canApprove() {
      return this.canApproveLock && String(this.budget?.status || "").toLowerCase() === "draft";
    },
    canLock() {
      return this.canApproveLock && String(this.budget?.status || "").toLowerCase() === "approved";
    },
  },
  created() {
    if (this.canApproveLock) {
      this.loadBudget();
    }
  },
  methods: {
    async loadBudget() {
      try {
        const res = await ApiService.get(`/budgets/${this.budgetId}`, { silent403: true });
        this.budget = res.data?.data ?? res.data ?? null;
      } catch (e) {
        this.budget = null;
      }
    },
    async approveBudget() {
      if (!this.canApprove) return;
      this.isProcessing = true;
      this.processingAction = "approve";
      try {
        await ApiService.post(`/budgets/${this.budgetId}/approve`, {}, { silent403: true });
        if (window.toast?.fire) {
          window.toast.fire({ icon: "success", title: "Budget approved successfully" });
        }
        await this.loadBudget();
      } catch (e) {
        if (e?.response?.status === 403 && window.toast?.fire) {
          window.toast.fire({ icon: "error", title: "No access" });
        }
      } finally {
        this.isProcessing = false;
        this.processingAction = "";
      }
    },
    async lockBudget() {
      if (!this.canLock) return;
      this.isProcessing = true;
      this.processingAction = "lock";
      try {
        await ApiService.post(`/budgets/${this.budgetId}/lock`, {}, { silent403: true });
        if (window.toast?.fire) {
          window.toast.fire({ icon: "success", title: "Budget locked successfully" });
        }
        await this.loadBudget();
      } catch (e) {
        if (e?.response?.status === 403 && window.toast?.fire) {
          window.toast.fire({ icon: "error", title: "No access" });
        }
      } finally {
        this.isProcessing = false;
        this.processingAction = "";
      }
    },
  },
};
</script>

